export interface EmploymentInfo {
  employmentStatus: EmploymentStatus;
  lastDayOfWork?: Date;
  designation: string;
  hireDate: Date;
  confirmedDate?: Date;
  passType: string;
  employmentType: string;
}

export interface CreateEmploymentInfo {
  employmentStatus: EmploymentStatus;
  hireDate: Date;
  designation: string;
  confirmedDate?: Date;
  passType: string;
  employmentType: string;
  lastDayOfWork?: Date;
}

export interface EmploymentInfoDTO {
  id: number;
  employmentStatus: EmploymentStatus;
  lastDayOfWork?: Date;
  designation: string;
  hireDate: Date;
  confirmedDate?: Date;
  passType: string;
  employmentType: string;
}
export enum EmploymentStatus {
  ACTIVE = "ACTIVE",
  RESIGNED = "RESIGNED",
}

export const EmploymentStatusLabel: { [key in EmploymentStatus]: string } = {
  [EmploymentStatus.ACTIVE]: "Active",
  [EmploymentStatus.RESIGNED]: "Resigned",
};
